export const css = {
	root: '_1G27JvyK',
	label: '_3XC_-EKb',
	closeIcon: 'qZQJWCAb',
	clickable: '_1JH9OtE6',
	disabled: '_3NJsoPXJ',
	' _key': 'afcpe-theme/dojo/chip'
};

export default css;
